/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://4fputbyhec.execute-api.eu-central-1.amazonaws.com/dev",
            "region": "eu-central-1"
        },
        {
            "name": "appsyncregister",
            "endpoint": "https://pu2zka94w5.execute-api.eu-central-1.amazonaws.com/dev",
            "region": "eu-central-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://wy5gxqo5xrdxtfqn6zwdu7llte.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-central-1:1f0eabba-42c2-47f1-84a0-4fc109009944",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_ATKG2AQjT",
    "aws_user_pools_web_client_id": "2vteqr92kvaejn0e4q941qp007",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-central-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "MagicBackendServiceAppSyncRegister",
            "region": "eu-central-1"
        }
    ],
    "aws_user_files_s3_bucket": "katman-image-storage183823-dev",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
